import { useEffect, useState } from 'react';
import { Grid, Typography, CircularProgress, Box, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import MainCard from '../../../component/cards/MainCard';
import { EditButton } from '../../../component/buttons';
import {
    useLearningPosts,
    useLearningPostsByTags,
    useLearningTags
} from '../../../hooks/useLearning';
import LearningCard from './LearningCard';
import LearningTagsFilterCard from './components/LearningTagsFilterCard';

function Aprender() {
    const navigate = useNavigate();
    const [selectedTags, setSelectedTags] = useState([]);
    const { data: tags = [], isLoading: tagsLoading } = useLearningTags();
    const learningAll = useLearningPosts();
    const learningByTags = useLearningPostsByTags(selectedTags);

    const {
        data: contents,
        isLoading,
        error,
        count,
        paginationModel,
        setPaginationModel
    } = selectedTags.length > 0 ? learningByTags : learningAll;

    useEffect(() => {
        if (selectedTags.length > 0) {
            learningByTags.setPaginationModel((prev) => ({ ...prev, page: 0 }));
        } else {
            learningAll.setPaginationModel((prev) => ({ ...prev, page: 0 }));
        }
    }, [selectedTags]);

    const handlePageChange = (event, newPage) => {
        setPaginationModel((prev) => ({ ...prev, page: newPage - 1 }));
    };

    const handleDelete = (id) => {};

    return (
        <MainCard title={t('learning.title')}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Grid container justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <EditButton onClick={() => navigate('/aprender/criar')}>
                                <Typography variant="subtitle2">
                                    {t('learning.add_new')}
                                </Typography>
                            </EditButton>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <LearningTagsFilterCard
                        tags={tags}
                        selectedTags={selectedTags}
                        onChange={setSelectedTags}
                    />
                </Grid>

                {isLoading ? (
                    <Grid item xs={12}>
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            p={4}
                        >
                            <CircularProgress />
                        </Box>
                    </Grid>
                ) : error ? (
                    <Grid item xs={12}>
                        <Typography color="error" align="center">
                            {t('learning.load_error')}
                        </Typography>
                    </Grid>
                ) : contents.length === 0 ? (
                    <Grid item xs={12}>
                        <Typography align="center">
                            {t('learning.none_available')}
                        </Typography>
                    </Grid>
                ) : (
                    <>
                        {contents.map((content) => (
                            <Grid key={content.uuid} item lg={4} md={6} sm={6} xs={12}>
                                <LearningCard
                                    content={content}
                                    onClick={() => navigate(`/aprender/${content.uuid}`)}
                                    onView={() => navigate(`/aprender/${content.uuid}`)}
                                    onEdit={() =>
                                        navigate(`/aprender/editar/${content.uuid}`)
                                    }
                                    onDelete={() => handleDelete(content.uuid)}
                                />
                            </Grid>
                        ))}

                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="center" mt={4}>
                                <Pagination
                                    count={Math.ceil(count / paginationModel.pageSize)}
                                    page={paginationModel.page + 1}
                                    onChange={handlePageChange}
                                />
                            </Box>
                        </Grid>
                    </>
                )}
            </Grid>
        </MainCard>
    );
}

export default Aprender;
